<template>
  <div
    class="theme-toggle"
    :class="{ 'theme-toggle--nav': layout === 'nav' }"
    @click="toggleTheme"
  >
    <div class="toggle-icon">
      <!-- Sun icon for light mode -->
      <svg
        v-if="isDark"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="5"
          stroke="currentColor"
          stroke-width="2"
        />
        <path
          d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <!-- Moon icon for dark mode -->
      <svg
        v-else
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, withDefaults } from 'vue'
import { useThemeStore } from '@/stores/theme'
import { syncColorModeToUrl } from '@/utils/syncColorModeToUrl'

withDefaults(
  defineProps<{
    /** `fixed` = floating control (desktop); `nav` = inline in app header */
    layout?: 'fixed' | 'nav'
  }>(),
  { layout: 'fixed' },
)

const themeStore = useThemeStore()

const isDark = computed(() => themeStore.isDark)

const toggleTheme = () => {
  themeStore.toggleMode()
  void syncColorModeToUrl(themeStore.mode)
}
</script>

<style scoped>
.theme-toggle {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  z-index: 1001;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.toggle-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--colour-surface-cont-lowest);
  border: 2px solid var(--colour-surface-cont);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--colour-base-text-colour);
  box-shadow: 0 2px 8px var(--shadow-color);
  position: relative;
  z-index: 1;
}

.theme-toggle--nav {
  position: static;
  top: auto;
  right: auto;
  transform: none;
  z-index: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.theme-toggle--nav .toggle-icon {
  width: 32px;
  height: 32px;
  border-width: 1px;
  box-shadow: none;
}

.theme-toggle--nav .toggle-icon svg {
  width: 20px;
  height: 20px;
}
</style>
